import * as React from 'react'
import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { NavLink } from 'react-router-dom'
import ButtonBase from '@material-ui/core/ButtonBase'
import { IconSeekers, IconButtonSeeker } from 'ui-seeker/core'
import { useTranslation } from 'react-i18next'
import { getAppUserData } from '../../../@utils'
import { ADMIN_MENU } from '../../../@common/constants'

const listData = Object.values(ADMIN_MENU)

const ICON_STYLE = { width: 20, textAlign: 'center', flexShrink: 0 }

export default function AdminSectionPanel({ isOpen, onClose }) {
    const { t } = useTranslation('navigation')
    const [expanded, setExpanded] = useState(null)
    const [portalTarget, setPortalTarget] = useState(null)
    const appUserData = getAppUserData()
    const userFeatures = appUserData.features?.[appUserData.uidSlave] || []

    useEffect(() => {
        setPortalTarget(document.querySelector('.sidenav') || document.body)
    }, [])

    const filteredOptions = listData.filter(item => {
        if (item.features?.length) return item.features.some(f => userFeatures.includes(f))
        if (item.feature && item.admin) return appUserData.role === 'admin' && userFeatures.includes(item.feature)
        if (item.feature) return userFeatures.includes(item.feature)
        if (item.masterOnly) return appUserData.role === 'master' || appUserData.role === 'admin'
        return (appUserData.role === 'admin' && item.admin) || (appUserData.role !== 'admin' && !item.admin)
    })

    if (!portalTarget) return null

    return ReactDOM.createPortal(
        <div className="navigation">
            <div className={`submenu ${isOpen ? 'active' : ''}`}>
                <div className="submenu-title mt-10 mb-30">
                    <IconButtonSeeker
                        className="submenu-back mr-10 pull-right text-middle"
                        icon="arrow-left" iconType="fontAwesome" size="small"
                        onClick={onClose}
                    />
                    <IconSeekers className="submenu-icon pl-10 text-middle" icon="cog" iconType="fontAwesome" />
                    <span className="text-middle pl-10 item-text">{t('adminPanel')}</span>
                </div>
                { filteredOptions.map((item, idx) =>
                    item.children ? <React.Fragment key={idx}>
                        <a className="nav-item" onClick={() => setExpanded(expanded === idx ? null : idx)}>
                            <ButtonBase className="w-100" style={{ justifyContent: 'flex-start' }}>
                                <IconSeekers className="item-icon text-middle" icon={item.icon || 'circle'} iconType="fontAwesome" style={ICON_STYLE} />
                                <span className="text-middle pl-10 item-text" style={{ marginRight: 'auto' }}>{item.i18nKey ? t(item.i18nKey) : item.label}</span>
                                <IconSeekers
                                    icon={expanded === idx ? 'chevron-down' : 'chevron-right'}
                                    iconType="fontAwesome"
                                    style={{ fontSize: 10, opacity: 0.7, marginRight: 4 }}
                                />
                            </ButtonBase>
                        </a>
                        { expanded === idx && item.children.map((child, cidx) =>
                            <NavLink key={`${idx}-${cidx}`} className="nav-item" to={child.route} onClick={onClose}>
                                <ButtonBase className="w-100" style={{ justifyContent: 'flex-start', paddingLeft: 20 }}>
                                    <span style={{ width: 20, textAlign: 'center', flexShrink: 0, fontSize: 14, opacity: 0.7 }}>●</span>
                                    <span className="text-middle pl-10 item-text" style={{ opacity: 0.8, fontSize: 13 }}>{child.i18nKey ? t(child.i18nKey) : child.label}</span>
                                </ButtonBase>
                            </NavLink>
                        )}
                    </React.Fragment> : (
                        <NavLink key={idx} className="nav-item" to={item.route} onClick={onClose}>
                            <ButtonBase className="w-100">
                                <IconSeekers className="item-icon text-middle" icon={item.icon || 'circle'} iconType="fontAwesome" style={ICON_STYLE} />
                                <span className="text-middle pl-10 item-text">{item.i18nKey ? t(item.i18nKey) : item.label}</span>
                            </ButtonBase>
                        </NavLink>
                    )
                )}
            </div>
        </div>,
        portalTarget
    )
}
